<template>
    <!-- <Header/> -->
    <Breadcrumb title="Antarësohu" subtitle="Antarësohu" />
    <ContactArea :title="selectedPackage.title" :price="selectedPackage.price" :packageID="selectedPackage.id" :pdfPath="selectedPackage.pdfPath" :discount="selectedPackage.discount"/>
    <Footer/>\
</template>

<script>
import { mapGetters } from 'vuex';

import Breadcrumb from '../../components/common/Breadcrumb.vue';
import ContactArea from '../../components/Contact/ContactArea.vue';
import Footer from '../../components/Home/Footer.vue';

export default {
  name: 'ContactPage',
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedPackage: {},
    };
  },
  computed: {
    ...mapGetters('offers', ['offers']), // map offers from Vuex store
  },
  components: {
    Breadcrumb,
    ContactArea,
    Footer,
  },
  created() {
    // fetch offers if not already loaded
    if (!this.offers || this.offers.length === 0) {
      this.$store.dispatch('offers/fetchOffers').then(() => {
        this.setSelectedPackage();
      });
    } else {
      this.setSelectedPackage();
    }
  },
  methods: {
    setSelectedPackage() {
      const match = this.offers.find(
        (p) => p.Id === Number.parseInt(this.id)
      );
      if (match) {
        this.selectedPackage = {
          id: match.Id,
          title: match.Title,
          price: match.Price,
          pdfPath: match.TermsDokumentPath,
          discount: match.Discount || 0
        };
      } else {
        this.$router.push('/');
      }
    },
  },
};
</script>
